import ClientGroupRegister from "./ClientGroupRegister";

export default ClientGroupRegister;
